import { type DataTableLoadingObject } from '@autone/ui';
import { createColumnHelper } from '@tanstack/react-table';

import { type TransformedAssortmentSkuLocationsItem } from '../../../redux/assortment/schemas/get-assortment-sku-locations.schema';
import {
  createCurrentUnitsColumn,
  createFirstSaleDateColumn,
  createLatestSaleDateColumn,
  createLocationClusterColumn,
  createParentLocationPendingFromProductionColumn,
  createPendingFromProductionColumn,
  createProductGroupsColumn,
  createTotalSalesUnitsColumn,
  createTotalSalesValueColumn,
  createWarehouseUnitsColumn,
} from '../common-columns';

import { createAutoneRecommendationColumn } from './columns/autone-recommendation.column';
import { createCurrentAssortmentColumn } from './columns/current-assortment.column';
import { createInitialAllocationColumn } from './columns/initial-allocation.column';
import { createLocationColumn } from './columns/location.column';
import { createScheduledEndDateColumn } from './columns/scheduled-end-date.column';
import { createScheduledStartDateColumn } from './columns/scheduled-start-date.column';
import { createSizeSkuColumn } from './columns/size-sku.column';
import { createSkuProductColumn } from './columns/sku-product.column';

const columnHelper = createColumnHelper<
  TransformedAssortmentSkuLocationsItem | DataTableLoadingObject
>();

export const skuLocationsTableColumnDefs = [
  createSkuProductColumn(columnHelper),
  createSizeSkuColumn(columnHelper),
  createLocationColumn(columnHelper),
  createLocationClusterColumn(columnHelper),
  createProductGroupsColumn(columnHelper),
  createCurrentAssortmentColumn(columnHelper),
  createAutoneRecommendationColumn(columnHelper),
  createInitialAllocationColumn(columnHelper),
  createTotalSalesUnitsColumn(columnHelper),
  createTotalSalesValueColumn(columnHelper),
  createFirstSaleDateColumn(columnHelper),
  createLatestSaleDateColumn(columnHelper),
  createCurrentUnitsColumn(columnHelper),
  createWarehouseUnitsColumn(columnHelper),
  createScheduledStartDateColumn(columnHelper),
  createScheduledEndDateColumn(columnHelper),
  createPendingFromProductionColumn(columnHelper),
  createParentLocationPendingFromProductionColumn(columnHelper),
];
